import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background noise-bg text-white flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center border border-white/10 rounded-2xl bg-white/[0.02] p-10" data-testid="payment-cancel-page">
        <div className="w-16 h-16 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center text-muted-foreground mx-auto mb-5">
          <XCircle className="w-9 h-9" />
        </div>
        <h1 className="font-display font-bold text-2xl">Pagamento annullato</h1>
        <p className="text-muted-foreground text-sm mt-2">
          Nessun addebito è stato effettuato. Puoi passare a Pro quando vuoi.
        </p>
        <div className="flex gap-3 justify-center mt-7">
          <Button onClick={() => navigate("/upgrade")} className="bg-primary text-black hover:bg-[#33F3FF] font-semibold h-11 px-6" data-testid="retry-upgrade-btn">
            Riprova
          </Button>
          <Button onClick={() => navigate("/dashboard")} className="bg-white/10 text-white hover:bg-white/15 font-semibold h-11 px-6">
            Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
